import ApplicationController from './application_controller';

// Connects to data-controller="video-player"
export default class extends ApplicationController {
  static targets = ['btn', 'player'];

  connect() {
    super.connect();
  }

  play() {
    this.playerTarget.play();
    this.btnTarget.style.display = 'none';
  }

  pause() {
    this.btnTarget.style.display = 'flex';
  }
}
